/* KV（maison-v9-hero）に GlyphHero を起動する。テーマエディタでのセクション再読み込みにも対応 */
(function () {
  'use strict';
  if (!window.GlyphHero) return;

  const mq = matchMedia('(max-width: 600px)');
  const instances = new Map();

  function cellFor(el) {
    const base = Number(el.dataset.cell) || 14;
    return mq.matches ? Math.max(6, Math.round(base * 0.65)) : base; // スマホはセルを細かく
  }

  function mountIn(root) {
    root.querySelectorAll('[data-glyph-hero]').forEach((el) => {
      if (instances.has(el) || !el.dataset.src) return;
      const hero = window.GlyphHero.mount(el, {
        src: el.dataset.src,
        crossOrigin: 'anonymous',
        mode: el.dataset.mode || 'subject',
        fps: Number(el.dataset.fps) || 5,
        opacity: Number(el.dataset.opacity) || 0.9,
        hover: el.dataset.hover === 'true',
        intro: el.dataset.intro === 'true' ? 2600 : 0,
        focusX: Number(el.dataset.focusX),
        focusY: 0.5,
        cell: cellFor(el),
      });
      instances.set(el, hero);
    });
  }

  function unmountIn(root) {
    for (const [el, hero] of instances) {
      if (root.contains(el)) {
        hero.destroy();
        instances.delete(el);
      }
    }
  }

  mq.addEventListener('change', () => {
    for (const [el, hero] of instances) hero.set({ cell: cellFor(el) });
  });

  document.addEventListener('shopify:section:load', (e) => mountIn(e.target));
  document.addEventListener('shopify:section:unload', (e) => unmountIn(e.target));

  mountIn(document);
})();
